var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 5.5A1.5 1.5 0 0 1 1.5 4h21A1.5 1.5 0 0 1 24 5.5v12.75a1.5 1.5 0 0 1-1.5 1.5h-21a1.5 1.5 0 0 1-1.5-1.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4095DB",
    fillRule: "evenodd",
    d: "M0 5.5A1.5 1.5 0 0 1 1.5 4h21A1.5 1.5 0 0 1 24 5.5v2.25H0z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B662",
    fillRule: "evenodd",
    d: "M0 16h24v2.25a1.5 1.5 0 0 1-1.5 1.5h-21a1.5 1.5 0 0 1-1.5-1.5z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071CE",
    fillRule: "evenodd",
    d: "M14.16 8.962c.44 0 .791.107 1.016.205l-.154 1.058-.102-.056c-.209-.099-.477-.194-.848-.187-.444 0-.649.217-.649.42-.003.229.24.379.636.605.654.348.956.77.952 1.326C15.002 13.346 14.23 14 13.038 14c-.509-.006-.999-.124-1.263-.26l.159-1.092.145.077c.373.182.614.256 1.068.256.326 0 .675-.15.678-.476.002-.214-.146-.367-.588-.606-.43-.233-1-.624-.992-1.326.006-.948.795-1.61 1.915-1.61m-3.52.086-.708 4.88h1.133l.709-4.88zm6.045 3.15c.094-.281.451-1.364.451-1.364-.003.006.018-.057.046-.144.032-.097.075-.225.105-.322l.076.42s.218 1.166.262 1.41zm.522-3.146h.876L19 13.93h-1.052s-.104-.56-.138-.73l-1.451-.003c-.045.132-.239.733-.239.733h-1.19l1.683-4.472c.119-.318.322-.405.594-.405M7.872 12.38l1.11-3.327h1.2l-1.784 4.87-1.2.002-1.014-4.268c.72.423 1.363 1.267 1.57 2.047z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B662",
    fillRule: "evenodd",
    d: "M6.843 9.048H5.015L5 9.15c1.422.404 2.363 1.38 2.753 2.553L7.356 9.46c-.068-.31-.267-.4-.513-.412",
    clipRule: "evenodd"
  })));
};
export default SvgVisa;